import { Grid } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Simplebar from 'components/Simplebar';
import React from 'react';

import { useAdvertisersDashboard } from '../AdvertisersDashboardContext';
import RemainingBudgetIndicator from './RemainingBudgetIndicator';
import RemainingBudgetSpentChart from './RemainingBudgetSpentChart';
import { getStats } from './utils';

const RemainingBudgetCard: React.FunctionComponent = () => {
  const { campaignBudget } = useAdvertisersDashboard();

  const { remainingMilliCents, usedPercentage } = getStats(campaignBudget.data);

  return (
    <Card>
      <CardHeader title="Remaining Budget" />
      <CardContent component={Simplebar}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <RemainingBudgetIndicator
              remainingBudgetMilliCents={remainingMilliCents}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <RemainingBudgetSpentChart spentBudgetPercentage={usedPercentage} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default RemainingBudgetCard;
